<template>
  <span class="tier-badge" :style="badge_style" v-tippy="tooltip">
    <img v-if="tier.icon" :src="tier.icon" alt="" :style="icon_style" />
    <span class="tier-badge-name">{{ tier.name || placeholder }}</span>
  </span>
</template>

<script>
import { PREVIEW_SIZES } from './tierModel';

export default {
  name: 'TierBadge',

  props: {
    tier: {
      type: Object,
      required: true,
    },
    // one of the PREVIEW_SIZES heights, everything else scales off it
    size: {
      type: Number,
      default: 32,
    },
    placeholder: {
      type: String,
      default: 'Tier name',
    },
  },

  computed: {
    spec() {
      return PREVIEW_SIZES.find((item) => item.size === this.size) || PREVIEW_SIZES[1];
    },

    badge_style() {
      return {
        height: `${this.spec.size}px`,
        padding: `0 ${this.spec.padding}px`,
        gap: `${this.spec.gap}px`,
        fontSize: `${this.spec.font}px`,
        // one picker drives both the text and the border
        color: this.tier.font_color,
        borderColor: this.tier.font_color,
        backgroundColor: this.tier.background_color,
      };
    },

    icon_style() {
      return { width: `${this.spec.icon}px`, height: `${this.spec.icon}px` };
    },

    tooltip() {
      return {
        content: this.tier.description,
        // the description is only worth a tooltip when there is one, and tippy has no empty-content
        // short circuit of its own: it would pop a blank padded box. onShow is its cancel hook.
        onShow: () => Boolean(this.tier.description),
      };
    },
  },
};
</script>
<style lang="scss">
// height, padding, gap, font size and icon size all come from PREVIEW_SIZES
.tier-badge {
  display: inline-flex;
  align-items: center;
  border: 1px solid;
  border-radius: 100px;
  font-family: var(--font-med);
  max-width: 100%;
  overflow: hidden;

  img {
    object-fit: contain;
    // the icon keeps its size, only the name gives way
    flex: none;
  }

  // truncation lives on the element that actually holds the text, not on the flex container
  .tier-badge-name {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
